import { takeLatest, call } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import history from '../../../utils/history';

export function* resetPasswordGen(payload) {
  const { email } = payload.payload;
  try {
    yield call(api, {
      method: 'post',
      url: URL.RESET_PASSWORD,
      data: {
        email,
      },
    });
    history.push('/auth/email');
  } catch (e) {
    yield call(toast.error, 'Error');
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.RESET_PASSWORD, resetPasswordGen);
}
